import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {FormSection} from '../../../../../../components/FormMaker/types';
import {ApplicantProfile} from '../../../types';

export const useLeadershipSection = (profile: ApplicantProfile): FormSection[] => {
  const {t} = useTranslation();

  return useMemo<FormSection[]>(
    () => [
      {
        type: 'radio',
        data: {
          name: 'leadershipExperience',
          label: t('applicantProfile.leadershipExperience.title'),
          options: [
            {label: t('shared.yes'), id: 'yes'},
            {label: t('shared.no'), id: 'no'},
          ],
          initialValue: profile.leadershipExperience ? 'yes' : 'no',
        },
      },
    ],
    [profile.leadershipExperience, t]
  );
};
